import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"


export default function AppDropoffOfficesAutocomplete({ ...props }) {
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false}
		label="Dropoff Office"
		placeholder="Same as pickup"
		{...props}
	/>
}
